import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import StyledTabs from "../../../shared/Tabs/StyledTabs";
import TabTitle from "../../../shared/Tabs/TabTitle";
import PlatformDefaults from "./PlatformDefaults";
import PersonalOverlayCss from "./PersonalOverlayCss";

const Subscriptions = () => {
  const { t } = useTranslation();

  return (
    <div className="flex-fill">
      <StyledTabs defaultKey="platformDefaults">
        <Tab
          eventKey="platformDefaults"
          title={<TabTitle icon="uil-sliders-v-alt" label={t("Backend.Settings.Tabs.PlatformDefaults", "Platform Defaults")} />}
        >
          <div style={{ marginTop: 24 }} />
          <Row>
            <Col>
              <PlatformDefaults />
            </Col>
          </Row>
        </Tab>

        <Tab
          eventKey="imageTitles"
          title={<TabTitle icon="uil-image-v" label={t("Backend.Settings.Tabs.ImageTitles", "Image Titles")} />}
        >
          <div style={{ marginTop: 24 }} />
          <Row>
            <Col lg={8}>
              <PersonalOverlayCss />
            </Col>
          </Row>
        </Tab>
      </StyledTabs>
    </div>
  );
};

export default Subscriptions;
